import React from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import MachineryListItem from './MachineryListItem';

const MachineryList = ({ machinery = [] }) => {
  return (
    <div className="row">
      <div className="col">
        {
          machinery.map((machine) => (
            <MachineryListItem key={machine.id} machine={machine} />
          ))
        }
      </div>
    </div>
  );
};

MachineryList.propTypes = {
  machinery: PropTypes.array,
};

export default withTranslation('common')(MachineryList);
